// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__+DuHK","content":"hero_content__FvQK-","getStartedBtn":"hero_getStartedBtn__mK6oW"};